import { ConfigSystemParams, SelectorItemWidgetGroupKeyType, WidgetGroupKeys } from "../../consts";
import { ConfigSystemService } from "../../services/utelize/system/config-system/config-system-service";

export interface SelectorItemWidgetGroup {
  key  : SelectorItemWidgetGroupKeyType;
  label: string;
};

export function getSelectorItems_WidgetGroup(configSystemService: ConfigSystemService): SelectorItemWidgetGroup[] {
  const showAlerts       =configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowWidgetsAlerts,        false);
  const showLicences     =configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowWidgetsLicences,      true );
  const showSimUsageCosts=configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowWidgetsSimUsageCosts, true );
  const showTotalCosts   =configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowWidgetsTotalCosts,    true );

  //CRN_20251128 - ⚠️ Below is the vertical order of Widget Rows ⚠️
  return [
    ...(showTotalCosts    ? [
                             { key  : WidgetGroupKeys.totalCosts as SelectorItemWidgetGroupKeyType,
                               label: "Total Costs"
                             }
                            ]
                          : []),
    ...(showSimUsageCosts ? [
                             { key  : WidgetGroupKeys.totalSimsUsageCosts as SelectorItemWidgetGroupKeyType,
                               label: "SIMs / Usage / Usage Costs"
                             }
                            ]
                          : []),
    ...(showLicences      ? [
                             { key  : WidgetGroupKeys.totalLicences as SelectorItemWidgetGroupKeyType,
                               label: "Licences"
                             }
                            ]
                          : []),
    ...(showAlerts        ? [
                             { key  : WidgetGroupKeys.totalAlerts as SelectorItemWidgetGroupKeyType,
                               label: "Alerts"
                             }
                            ]
                          : []),
  ];
}
